import { render } from "./processed.vue?vue&type=template&id=104c06f1&scoped=true"
import script from "./processed.vue?vue&type=script&lang=js"
export * from "./processed.vue?vue&type=script&lang=js"

import "./processed.vue?vue&type=style&index=0&id=104c06f1&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lidu/礼度管理后台-CRA端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104c06f1"]])

export default __exports__